var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    clipPath: "url(#clip0_287_19650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 16.0007H14C14.55 16.0007 15 15.5507 15 15.0007V10.0007H16.59C17.48 10.0007 17.93 8.9207 17.3 8.2907L12.71 3.7007C12.32 3.3107 11.69 3.3107 11.3 3.7007L6.71 8.2907C6.08 8.9207 6.52 10.0007 7.41 10.0007H9V15.0007C9 15.5507 9.45 16.0007 10 16.0007ZM6 18.0007H18C18.55 18.0007 19 18.4507 19 19.0007C19 19.5507 18.55 20.0007 18 20.0007H6C5.45 20.0007 5 19.5507 5 19.0007C5 18.4507 5.45 18.0007 6 18.0007Z",
    fill: "#2B8C34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_19650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b5f200a52147cef0ddb93012cb681a73.svg";
export { ForwardRef as ReactComponent };